/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { PageTypeData } from '@/types';
import { type ProductData } from '@/features/product';

type GetPageDependentPrefooterParamsArgs = {
  isPDP: boolean;
  pageTypeData: PageTypeData | undefined;
  productDetails: ProductData | undefined;
  acesEnabled: boolean;
};

type PageDependentParams = {
  pageType: string | undefined;
  catalogRepositoryId: string | undefined;
  categoryIdPath: string | undefined;
  shopByMakeActive: boolean | undefined;
  shopByModelActive: boolean | undefined;
  shopByYearActive: boolean | undefined;
  taxonomyPath: string | undefined;
  filterName: string | undefined;
  shopByMakeName: string | undefined;
  shopByMakeId: string | undefined;
  shopByModelName: string | undefined;
  shopByYear: string | undefined;
};

const getPageDependentPrefooterParams = ({
  isPDP,
  pageTypeData,
  productDetails,
  acesEnabled,
}: GetPageDependentPrefooterParamsArgs): PageDependentParams => {
  if (isPDP) {
    return {
      pageType: 'ProductDetails',
      catalogRepositoryId: acesEnabled
        ? (productDetails?.product?.partGroupId ?? productDetails?.product?.ecommProductId)
        : productDetails?.product?.ecommProductId,
      categoryIdPath: productDetails?.product?.categoryId,
      shopByMakeActive: productDetails?.product?.shopByMakeActive,
      shopByModelActive: productDetails?.product?.shopByModelActive,
      shopByYearActive: productDetails?.product?.shopByYearActive,
      taxonomyPath: productDetails?.product?.taxonomyUrl,
      filterName: productDetails?.product?.partTypeName,
      shopByMakeName: undefined,
      shopByMakeId: undefined,
      shopByModelName: undefined,
      shopByYear: undefined,
    };
  }

  return {
    pageType: pageTypeData?.pageType,
    catalogRepositoryId: pageTypeData?.catalogRepositoryId,
    categoryIdPath: pageTypeData?.categoryRepositoryIdPath,
    shopByMakeActive: pageTypeData?.shopByMakeActive,
    shopByModelActive: pageTypeData?.shopByModelActive,
    shopByYearActive: pageTypeData?.shopByYearActive,
    taxonomyPath: pageTypeData?.taxonomyPath,
    filterName: pageTypeData?.catalogRepositoryName,
    shopByMakeName: pageTypeData?.make ?? undefined,
    shopByMakeId: pageTypeData?.makeId ?? undefined,
    shopByModelName: pageTypeData?.model ?? undefined,
    shopByYear: pageTypeData?.year ?? undefined,
  };
};

export { getPageDependentPrefooterParams };
